import { MetaFunction } from "@remix-run/node";
import { Link } from "@remix-run/react";
import { Button } from "~/components/ui/button";

export const meta: MetaFunction = () => {
  return [
    { title: "Página no encontrada | Compartir Espacios" },
    { name: "description", content: "Lo sentimos, la página que buscas no existe." },
    { name: "robots", content: "noindex" }
  ];
};

export default function NotFound() {
  return (
    <main className="flex flex-1 flex-col gap-4 bg-muted/40 p-4 md:gap-8 md:p-10">
      <div className="container mx-auto flex flex-col items-center justify-center py-16 text-center">
        <h1 className="text-4xl font-bold mb-4">404 - Página no encontrada</h1>
        <p className="text-lg text-gray-600 mb-8 max-w-md">
          Lo sentimos, la página que estás buscando no existe o ha sido movida.
        </p>
        <div className="flex gap-4">
        <Button asChild>
          <Link to="/">Volver al inicio</Link>
        </Button>
        <Button variant="outline" asChild>
          <Link to="/solicitar-espacio">Solicitar un espacio</Link>
        </Button>
        </div>
      </div>
    </main>
  );
}
